import "./Tuyendung.css";
export default function Schedule() {
  return (
    <section id="lich">
      <div className="wrap">
        <div className="sec-head">
          <div className="sec-eyebrow">Thời gian & lương</div>
          <h2 className="sec-title">Giờ làm rõ ràng, lương về đúng hẹn</h2>
        </div>

        <div className="schedule-grid">
          <div className="day-strip">
            <div className="schedule-title">Lịch làm việc trong ngày</div>
            <div className="schedule-description">Làm việc từ 8 giờ sáng đến 20 giờ tối, nghỉ trưa từ 12 giờ đến 13 giờ.</div>
            <div className="day-track">
              <div className="day-seg work1">Sáng</div>
              <div className="day-seg lunch" />
              <div className="day-seg work2">Chiều – Tối</div>
            </div>
            <div className="day-marks"><span>8:00</span><span>12:00</span><span>13:00</span><span>20:00</span></div>
          </div>

          <div className="pay-card">
            <div className="big">Ngày 10</div>
            <div className="small">hằng tháng</div>
            <p>Nhận lương qua hình thức chuyển khoản trực tiếp vào tài khoản ngân hàng của bạn, đúng hẹn mỗi tháng.</p>
          </div>
        </div>
      </div>
    </section>
  );
}